import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { FeatureService } from '../services/feature.service';

@Injectable()
export class FeatureGuard implements CanActivate {

    constructor(private featureService: FeatureService, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const requiredFeature = route.data['feature'];
        if (this.featureService.hasFeature(requiredFeature)) {
            return true;
        }

        this.router.navigate(['/']);
        return false;
    }
}
